import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getErrorMessage } from 'shared/utils/errorMessage';
import { useMenuList } from 'features/master-data';
import { menuListRole } from 'shared/constants/menu-catalog';

/**
 * Fetches the menu master-data and derives the menu list shape used by the
 * role form (available menus filtered by visibility + ancestor menus).
 *
 * @returns {{ availableMenus, menus, isLoadingMenus, refetchMenus }}
 */
const useRoleMenus = () => {
  const {
    data: menusData,
    isLoading: isLoadingMenus,
    isError,
    refetch: refetchMenus,
  } = useMenuList();

  // Surface fetch errors as toast on transition to error state.
  useEffect(() => {
    if (isError) {
      toast.error(`Get menus: ${getErrorMessage(new Error('fetch failed'))}`);
    }
  }, [isError]);

  const [availableMenus, setAvailableMenus] = useState([]);
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    if (!menusData) return;
    if (menusData?.meta?.http_status !== 200 || !menusData.data?.length) return;

    const mappedAllMenu = [];
    const mappedMenu = [];

    menusData.data.forEach((menu) => {
      if (menu.sub_menus) {
        menu.sub_menus.forEach((sub) => {
          if (sub.is_shown) {
            mappedMenu.push(sub);
            mappedAllMenu.push(menu);
          }
        });
      } else if (menu.is_shown) {
        mappedMenu.push(menu);
      }
    });

    const filteredMenuListRole = menuListRole.filter((menu) =>
      mappedMenu.find((m) => m.id === menu.menu_id)
    );

    setAvailableMenus(filteredMenuListRole);
    setMenus([...mappedAllMenu, ...mappedMenu]);
  }, [menusData]);

  return { availableMenus, menus, isLoadingMenus, refetchMenus };
};

export default useRoleMenus;
